import { useMemo } from "react";

const labels = {
  English: {
    noRecord: "No reference requests record",
    notFound: "Reference requests not found",
    referee: "Referee",
    referees: "Referees",
    status: "Status",
    noStatus: "No Status",
    inProgress: "In Progress",
    completed: "Completed",
    expired: "Expired",
    search: "Search by reference request...",
    referenceRequest: "Reference Request",
    referenceRequestDesc:
      "Manage and track reference checks for your applicants.",
    referenceRequestList: "Reference Request List",
    referenceRequestListDesc: "Overview of all reference requests.",
    applicants: "Applicants",
    jobName: "Job Name",
    dateSent: "Date Sent",
    dueDate: "Due Date",
    actions: "Actions",
    viewReports: "View Reports",
    hideReports: "Hide Reports",
    viewReferee: "View Referee",
    Edit: "Edit",
    Delete: "Delete",
    manageTrackTooltip:
      "Review and manage reference requests for candidates, track their status, and take action.",
    Status_InProgress: "In Progress",
    Status_Completed: "Completed",
    Status_Expired: "Expired",
    Status_New: "New",
    deleteConfirmation:
      "Would you like to confirm to delete this reference request?",
    yes: "Yes",
    no: "No",
    professionalReferenceFor: "Professional Reference for",
    referenceStatus: "Reference Status",
    requestInformation: "Request Information",
    questionFormat: "Question Format",
    dateDue: "Date Due",
    referenceDetails: "Reference Details",
    applicantInformation: "Applicant Information",
    name: "Name",
    email: "Email",
    refereeInformation: "Referee Information",
    viewReference: "View Reference",
    sendReminder: "Send Reminder",
    sending: "Sending...",
    formats: {
      hrHatch: "Snappcheck Format",
      custom: "Custom Format",
      na: "Not Available",
    },
    loading: "Loading Reference Request...",
    pleaseWait: "Please wait while we fetch the reference data",
    returnToReference: "Return to Reference Request",
    notAvailable: "Not Available",
    noImage: "No image available",
    idDisplayed: "ID displayed here...",
    signatureDisplay: "Signature here...",
    downloading: "Downloading...",
    downloadReference: "Download Reference",
    positionAppliedFor: "Position Applied For",
    applicant: "Applicant",
    refereeName: "Referee Name",
    currentCompany: "Current Company",
    companyWorkedWith: "Company you worked with",
    relationshipToApplicant: "Relationship to the Applicant",
    datesWorkedTogether: "Dates Worked Together",
    from: "From",
    to: "To",
    question: "Question",
    verification: "VERIFICATION",
    date: "Date",

    relationship: "Relationship",
    jobResponsibilitiesAndPerformance: "Job Responsibilities and Performance",
    skillAndCompetencies: "Skills and Competencies",
    workEthicAndBehavior: "Work Ethic and Behavior",
    closingQuestions: "Closing Questions",
    strategicLeadershipAndVision: "Strategic Leadership and Vision",
    businessImpactAndResults: "Business Impact and Results",
    teamLeadershipAndOrganizationalDevelopment:
      "Team Leadership and Organizational Development",
    decisionMakingAndProblemSolving: "Decision Making and Problem Solving",
    innovationAndGrowth: "Innovation and Growth",
    leadershipAndManagementSkills: "Leadership and Management Skills",

    overallJobPerformance: "Overall Job Performance Assessment:",
    overallSkillsCompetencies: "Overall Assessment of Skills and Competencies:",
    overallWorkEthicBehavior:
      "Overall Evaluation Regarding Work Ethic and Behavior:",
    overallLeadershipManagement:
      "Overall Performance in Leadership and Management:",
    overallStrategicLeadership: "Overall Assessment of Strategic Leadership:",
    overallBusinessImpact: "Overall Assessment of Business Impact and Results:",
    overallTeamLeadership:
      "Overall Assessment of Team Leadership and Organizational Development:",
    overallDecisionMaking:
      "Overall Assessment of Decision Making and Problem Solving:",
    overallInnovation: "Overall Assessment of Innovation and Growth:",
    overallAssessment: "Overall Assessment:",
    originalAnswer: "Original Answer",
    aiEnhancedAnswer: "AI Enhanced Answer",
    standardFormat: "Standard Format",
    managementFormat: "Management Format",
    executiveFormat: "Executive Format",
    editReferenceRequest: "Edit Referee Details",
    refereesName: "Referee's Name:",
    refereesEmail: "Email: ",
    updating: "Updating...",
    updateRequest: "Update Request",
    editReferee: "Edit Referee",
    firstName: "First Name:",
    lastName: "Last Name:",
  },
  Japanese: {
    noRecord: "リファレンス依頼の記録がありません",
    notFound: "リファレンス依頼が見つかりません",
    referee: "推薦者",
    referees: "推薦者",
    status: "ステータス",
    noStatus: "ステータスなし",
    inProgress: "進行中",
    completed: "完了",
    expired: "期限切れ",
    search: "リファレンス依頼で検索...",
    referenceRequest: "リファレンス依頼",
    referenceRequestDesc: "応募者のリファレンスチェックを管理し、追跡します。",
    referenceRequestList: "リファレンス依頼 リスト",
    referenceRequestListDesc: "すべてのリファレンス依頼の概要。",
    applicants: "応募者",
    jobName: "職種名",
    dateSent: "送信日",
    dueDate: "期限日",
    actions: "操作",
    viewReports: "レポートを見る",
    hideReports: "レポートを隠す",
    viewReferee: "推薦者を見る",
    Edit: "編集",

    Delete: "削除",
    manageTrackTooltip:
      "候補者のリファレンス依頼を確認し、ステータスを追跡して、アクションを実行します。",
    Status_InProgress: "進行中",
    Status_Completed: "完了",
    Status_Expired: "期限切れ",
    Status_New: "新規",
    deleteConfirmation: "このリファレンス依頼を削除してもよろしいですか？",
    yes: "はい",
    no: "いいえ",
    professionalReferenceFor: "業務リファレンス",
    referenceStatus: "リファレンスステータス",
    requestInformation: "依頼情報",
    questionFormat: "質問フォーマット",
    dateDue: "期限日",
    referenceDetails: "リファレンス詳細",
    applicantInformation: "応募者情報",
    name: "氏名",
    email: "メールアドレス",
    refereeInformation: "リファレンス提供者情報",
    viewReference: "リファレンスを見る",
    sendReminder: "リマインダーを送信",
    sending: "送信中...",
    formats: {
      hrHatch: "Snappcheckフォーマット",
      custom: "カスタムフォーマット",
      na: "利用不可",
    },
    loading: "リファレンス依頼を読み込んでいます...",
    pleaseWait: "リファレンスデータを取得中です。お待ちください。",
    returnToReference: "リファレンス依頼に戻る",
    notAvailable: "利用不可",
    noImage: "画像がありません",
    idDisplayed: "IDがここに表示されます...",
    signatureDisplay: "署名がここに...",
    downloading: "ダウンロード中...",
    downloadReference: "リファレンスをダウンロード",
    positionAppliedFor: "応募職種",
    applicant: "応募者",
    refereeName: "推薦者名",
    currentCompany: "現在の会社",
    companyWorkedWith: "一緒に働いていた会社",
    relationshipToApplicant: "応募者との関係",
    datesWorkedTogether: "一緒に働いた期間",
    from: "から",
    to: "まで",
    question: "質問",
    verification: "検証",
    date: "日付",
    relationship: "関係性",
    jobResponsibilitiesAndPerformance: "職務責任とパフォーマンス",
    skillAndCompetencies: "スキルと能力",
    workEthicAndBehavior: "職業倫理と行動",
    closingQuestions: "最終質問",
    strategicLeadershipAndVision: "戦略的リーダーシップとビジョン",
    businessImpactAndResults: "ビジネスへの影響と結果",
    teamLeadershipAndOrganizationalDevelopment:
      "チームリーダーシップと組織開発",
    decisionMakingAndProblemSolving: "意思決定と問題解決",
    innovationAndGrowth: "イノベーションと成長",
    leadershipAndManagementSkills: "リーダーシップとマネジメントスキル",
    overallJobPerformance: "総合的な職務パフォーマンス評価：",
    overallSkillsCompetencies: "スキルと能力の総合評価：",
    overallWorkEthicBehavior: "職業倫理と行動に関する総合評価：",
    overallLeadershipManagement: "リーダーシップとマネジメントの総合評価：",
    overallStrategicLeadership: "戦略的リーダーシップの総合評価：",
    overallBusinessImpact: "ビジネスへの影響と結果の総合評価：",
    overallTeamLeadership: "チームリーダーシップと組織開発の総合評価：",
    overallDecisionMaking: "意思決定と問題解決の総合評価：",
    overallInnovation: "イノベーションと成長の総合評価：",
    overallAssessment: "総合評価：",
    originalAnswer: "オリジナルの回答",
    aiEnhancedAnswer: "AI強化された回答",
    standardFormat: "標準フォーマット",
    managementFormat: "マネジメントフォーマット",
    executiveFormat: "エグゼクティブフォーマット",
    editReferenceRequest: "推薦者詳細を編集",
    refereesName: "推薦者名：",
    refereesEmail: "メールアドレス: ",
    updating: "更新中...",
    updateRequest: "依頼を更新",
    editReferee: "推薦者を編集",
    firstName: "名:",
    lastName: "姓:",
  },
};

export const useLabels = (language = "English") => {
  const currentLabels = useMemo(() => {
    return labels[language] || labels.English;
  }, [language]);

  return {
    labels: currentLabels,
  };
};
